const drawer = "_086d1ugsm42";
const content = "_086cjn970e";

export { content, drawer };
import "./tool.context-menu.style.linaria.module.css";
//# sourceMappingURL=tool.context-menu.style.js.map
